import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./ScreenTemplate.css"
import { ImgMobileHomeScreen1, NewScreen1Background } from "../../assets";

const ScreenTemplate = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenWebsiteRef = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenWebsiteRef.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: windowWidthClass==="w-mob"? ImgMobileHomeScreen1: NewScreen1Background,
                alt: ""
            }
        },
        shield: {

        },
        content: {

        }
    }
    
    return(
        <>
            <div 
            ref={screenWebsiteRef} 
            className={`${windowWidthClass}-screen-new-1 wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display">
                    {/* <h1>new screen content</h1> */}
                    <div className="text-div part-1">
                        <h1 className="tagline-1">What if there's</h1>
                        <h2 className="tagline-2">500 years old heritage food knowledge from Indonesia</h2>
                        <h4 className="tagline-4">can be a hope for our food system?</h4>
                    </div>
                </div>

            </div>
        </>
        
    )
};

export default ScreenTemplate;